<template>
  <BaseControlBar v-if="inputVal">
  <!-- <BaseControlBar :back-url="backUrl" v-if="inputVal"> -->
    <template v-if="role === 'admin'" class="flex-grow-1 d-flex">
      <div class="d-flex align-items-center flex-grow-1 section-header__title">
        <h1>{{ title }}</h1>
        <StatusLabel :item="status"></StatusLabel>
      </div>
      <template v-if="!readOnly">
        <BaseButton variant="outline-secondary"
                    @click="onCancel"
                    class="app--mobile-hidden"
        >
          取消
        </BaseButton>
        <BaseButton @click="onSave" class="app--mobile-hidden">
          儲存
        </BaseButton>
      </template>
      <template v-else>
        <div class="admin-actions app--mobile-hidden">
            <ButtonEdit variant="outline-secondary"
                        @click="onEdit"
            >
              編輯
            </ButtonEdit>
            <ButtonApprove v-if="isPermit('APPROVE')"
                          @click="prepareAction('ACTIVATE')"
            >
              批准
            </ButtonApprove>
            <ButtonApprove v-if="isPermit('ACTIVATE')"
                          @click="prepareAction('ACTIVATE', '你已啓用這個用戶')"
            >
              啓動
            </ButtonApprove>
            <ButtonApprove v-if="isPermit('REAPPROVE')"
                          @click="prepareAction('ACTIVATE')"
            >
              重新批准
            </ButtonApprove>
            <ButtonReject v-if="isPermit('REJECT')"
                          @click="prepareAction('REJECT')"
            >
              拒絕
            </ButtonReject>
            <ButtonReject v-if="isPermit('DEACTIVATE')"
                          @click="prepareAction('DEACTIVATE', '你已停用這個用戶')"
            >
              停用
            </ButtonReject>
            <ButtonSubMerchant :merchantId="this.inputVal.id"></ButtonSubMerchant>
            <BaseButton v-if="isPermit('SHOW_COUPONS')"
                        variant="outline-secondary"
                        @click="viewMerchantCoupons"
            >
              此商戶優惠
            </BaseButton>
            <ButtonRemove v-if="isPermit('REMOVE')"
                          @click="prepareAction('REMOVE', '你已移除這個用戶')"
            >
              移除
            </ButtonRemove>
            <AdminActionConfirmModal v-model="approval"
                                    :onCouponStatusUpdate="onStatusUpdate$"
                                    :loading="loading"
            ></AdminActionConfirmModal>
            <ActionSuccessModal v-model="actionSuccessModal"></ActionSuccessModal>
            <ListModalSubMerchant :type="'list'"
                                  :merchantId="this.inputVal.id">
            </ListModalSubMerchant>
          </div>
      </template>

    </template>

    <template v-if="role === 'sale'" class="flex-grow-1 d-flex">
      <div class="d-flex align-items-center flex-grow-1 section-header__title">
        <h1>{{ title }}</h1>
        <StatusLabel :item="status"></StatusLabel>
      </div>
      <template v-if="!readOnly">
        <BaseButton variant="outline-secondary"
                    @click="onCancel"
                    class="app--mobile-hidden"
        >
          取消
        </BaseButton>
        <BaseButton @click="onSave" class="app--mobile-hidden">
          儲存
        </BaseButton>
      </template>
      <template v-else>
        <div class="admin-actions app--mobile-hidden">
            <ButtonEdit variant="outline-secondary"
                        @click="onEdit"
            >
              編輯
            </ButtonEdit>
            <ButtonSubMerchant :merchantId="this.inputVal.id"></ButtonSubMerchant>
            <BaseButton v-if="isPermit('SHOW_COUPONS')"
                        variant="outline-secondary"
                        @click="viewMerchantCoupons"
            >
              此商戶優惠
            </BaseButton>
            <AdminActionConfirmModal v-model="approval"
                                    :onCouponStatusUpdate="onStatusUpdate$"
                                    :loading="loading"
            ></AdminActionConfirmModal>
            <ActionSuccessModal v-model="actionSuccessModal"></ActionSuccessModal>
            <ListModalSubMerchant :type="'list'"
                                  :merchantId="this.inputVal.id">
            </ListModalSubMerchant>
          </div>
      </template>

    </template>

    <template v-if="role === 'merchant'">
      <div class="d-flex align-items-center flex-grow-1 section-header__title">
        <h1>帳戶設定</h1>
      </div>
      <template v-if="!readOnly">
        <BaseButton variant="outline-secondary" @click="onCancel" class="app--mobile-hidden">
          取消
        </BaseButton>
        <BaseButton @click="onSave" class="app--mobile-hidden">
          儲存
        </BaseButton>
      </template>
      <template v-else>
        <ButtonEdit variant="outline-secondary"
                    @click="onEdit"
                    class="admin-actions app--mobile-hidden"
        >
          編輯
        </ButtonEdit>
      </template>
    </template>

    <!-- button-for-mobile start -->
    <template v-slot:secondRow>
      <template v-if="!readOnly">
        <div class="coupon-overview-wrapper app--hidden app--mobile-shown">
          <div class="overview-wrapper">
            <div class="overview">
              <div class="right">
                <BaseButton variant="none" @click="onCancel" class="mobile-btn">
                  取消
                </BaseButton>
              </div>
            </div>
            <div class="overview">
              <div class="right">
                <BaseButton @click="onSave" class="mobile-btn mobile-btn-blue" variant="none">
                  儲存
                </BaseButton>
              </div>
            </div>
          </div>
        </div>
      </template>
      <template v-else>
        <div class="coupon-overview-wrapper app--hidden app--mobile-shown">
          <div class="overview-wrapper">
            <div class="overview">
              <div class="right">
                <ButtonEdit
                  @click="onEdit"
                  class="mobile-btn mobile-btn-blue"
                >
                   編輯
                </ButtonEdit>
              </div>
            </div>
            <div class="overview" v-if="isPermit('APPROVE') && role === 'admin'">
              <div class="right">
                <ButtonApprove
                  @click="prepareAction('ACTIVATE')"
                  class="mobile-btn mobile-btn-green"
                >
                  批准
                </ButtonApprove>
              </div>
            </div>
            <div class="overview" v-if="isPermit('ACTIVATE') && role === 'admin'">
              <div class="right">
                <ButtonApprove
                  @click="prepareAction('ACTIVATE', '你已啓用這個用戶')"
                  class="mobile-btn mobile-btn-green"
                >
                  啓動
                </ButtonApprove>
              </div>
            </div>
            <div class="overview" v-if="isPermit('REAPPROVE') && role === 'admin'">
              <div class="right">
                <ButtonApprove
                  @click="prepareAction('ACTIVATE')"
                  class="mobile-btn mobile-btn-green"
                >
                  重新批准
                </ButtonApprove>
              </div>
            </div>
            <div class="overview" v-if="isPermit('REJECT') && role === 'admin'">
              <div class="right">
                <ButtonReject
                  @click="prepareAction('REJECT')"
                  class="mobile-btn mobile-btn-red"
                >
                  拒絕
                </ButtonReject>
              </div>
            </div>
            <div class="overview" v-if="isPermit('DEACTIVATE') && role === 'admin'">
              <div class="right">
                <ButtonReject
                  @click="prepareAction('DEACTIVATE', '你已停用這個用戶')"
                  class="mobile-btn mobile-btn-red"
                >
                  停用
                </ButtonReject>
              </div>
            </div>
            <div class="overview" v-if="role === 'admin' || role === 'sale'">
              <div class="right">
                <div class="icon"></div>
                <b-button v-b-modal.modal-multi-list
                          class="mobile-btn sub-merchant">
                  管理附屬帳戶
                </b-button>
              </div>
            </div>
            <div
              class="overview"
              v-if="isPermit('SHOW_COUPONS') && (role === 'admin' || role === 'sale')"
            >
              <div class="right">
                <BaseButton
                  variant="outline-secondary"
                  @click="viewMerchantCoupons"
                  class="mobile-btn"
                >
                  此商戶優惠
                </BaseButton>
              </div>
            </div>
            <div class="overview" v-if="isPermit('REMOVE') && role === 'admin'">
              <div class="right">
                <ButtonRemove
                  @click="prepareAction('REMOVE', '你已移除這個用戶')"
                  class="mobile-btn"
                >
                  移除
                </ButtonRemove>
              </div>
            </div>
          </div>
        </div>
      </template>
    </template>
    <!-- button-for-mobile end -->
  </BaseControlBar>
</template>

<script>
import { switchMap, tap } from 'rxjs/operators';
import { mapGetters } from 'vuex';
import http from '@/helpers/http';
import vModelMixin from '@/mixins/v-model';
import controlBarMixin from '@/mixins/control-bar';
import BaseButton from '@/components/BaseButton.vue';
import BaseControlBar from '@/components/BaseControlBar.vue';
import ButtonEdit from '@/components/button/ButtonEdit.vue';
import ButtonApprove from '@/components/button/ButtonApprove.vue';
import ButtonReject from '@/components/button/ButtonReject.vue';
import ButtonRemove from '@/components/button/ButtonRemove.vue';
import AdminActionConfirmModal from '@/components/coupon/AdminActionConfirmModal.vue';
import ActionSuccessModal from '@/components/ActionSuccessModal.vue';
import getStatus from '@/helpers/status';
import StatusLabel from '@/components/StatusLabel.vue';
import ButtonSubMerchant from '@/components/sub-merchant/ButtonSubMerchant.vue';
import ListModalSubMerchant from '@/components/sub-merchant/ModalList.vue';

export default {
  mixins: [vModelMixin, controlBarMixin],
  props: {
    title: String,
  },
  components: {
    BaseButton,
    BaseControlBar,
    ButtonEdit,
    ButtonApprove,
    ButtonReject,
    ButtonRemove,
    AdminActionConfirmModal,
    ActionSuccessModal,
    StatusLabel,
    ButtonSubMerchant,
    ListModalSubMerchant,
  },
  data: () => ({
    availableActions: {
      PENDING: ['APPROVE', 'REJECT', 'REMOVE'],
      ACTIVATED: ['DEACTIVATE', 'SHOW_COUPONS', 'REMOVE'],
      INACTIVATED: ['ACTIVATE', 'SHOW_COUPONS', 'REMOVE'],
      REJECTED: ['REAPPROVE', 'REMOVE'],
    },
    approval: {
      modal: false,
      action: null,
      remarks: null,
    },
    actionSuccessModal: {
      show: false,
      action: null,
      msg: null,
      back: {
        location: '/admin/merchants',
        text: '返回商戶列表',
      },
    },
    loading: false,
  }),
  domStreams: ['onStatusUpdate$'],
  subscriptions() {
    return {
      listener$: this.onStatusUpdate$
        .pipe(
          tap(() => {
            this.loading = true;
          }),
          switchMap(() => {
            const { action, remarks, msg } = this.approval;
            return http(
              {
                method: 'POST',
                url: `/agc-${this.role}-api/merchants/${action.toLowerCase()}`,
                data: {
                  merchantId: this.inputVal.id,
                  remarks: remarks || '',
                },
              },
              {
                next: ({ status }) => {
                  this.inputVal.status = status;
                  if (msg) {
                    this.actionSuccessModal = {
                      ...this.actionSuccessModal,
                      show: true,
                      action,
                      msg,
                    };
                  }
                },
                complete: () => {
                  this.approval.modal = false;
                  this.loading = false;
                },
              },
            );
          }),
        ),
    };
  },
  methods: {
    prepareAction(action, msg) {
      this.approval = {
        modal: true,
        action,
        remarks: null,
        msg,
      };
    },
    isPermit(action) {
      const actions = this.availableActions[this.inputVal.status];
      if (!actions) return false;
      return actions.indexOf(action) >= 0;
    },
    viewMerchantCoupons() {
      this.$router.push({
        path: `/${this.role}/coupons`,
        query: {
          keywordType: 'merchantId',
          q: this.inputVal.id,
        },
      });
    },
  },
  computed: {
    ...mapGetters(['role']),
    backUrl() {
      return (this.role === 'admin' || this.role === 'sale') ? `/${this.role}/merchants` : null;
    },
    status() {
      return getStatus(this.inputVal);
    },
  },
};
</script>

<style scoped lang="scss">
.admin-actions {
  display: flex;
}

.coupon-overview-wrapper {
  background-color: #fff;
  width: 100%;
  display: inline-block;
  color: #fff;
  position: relative;
  margin-bottom: 10px;

  .overview-wrapper {
    width: 100%;
    display: flex;
    justify-content: space-between;

    .overview {
      width: 100%;
      color: #000;
      display: flex;
      justify-content: space-between;
      box-sizing: border-box;

      .left {
        width: 100%;
        display: flex;
        flex-wrap: wrap;
        flex-direction: column;
        align-content: space-between;
      }
      .right {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        border-right: 1px solid #ccc;
        flex-wrap: wrap;
        margin: 10px 0px;
      }

      .icon {
        display: inline-block;
        position: relative;
        width: 22px;
        height: 23px;
        background-image: url(../../assets/img/icon/home.svg);
      }
    }

    .overview:last-child {
      .right {
        border: 0px;
      }
    }
  }
}

@include respond(tab-landscape) {
  .app--mobile-shown {
    display: block !important;
  }

  .app--mobile-hidden {
    display: none !important;
  }

  .mobile-btn-grey {
    color: gray !important;
  }

  .mobile-btn-blue {
    color: #3596f4 !important;
  }

  .mobile-btn-green {
    color: green !important;
  }

  .mobile-btn-red {
    color: red !important;
  }
}

@include respond(tab-landscape) {
  .mobile-btn {
    flex-direction: column;
    background: none;
    border: none;
    color: gray;

    &.sub-merchant{
      font-size: 0.85em;
    }
  }
}
</style>
